import {CanalNotificationWithSubscribeInformationDto, INotificationsWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class GestionCanauxResolver implements Resolve<Array<CanalNotificationWithSubscribeInformationDto>> {

  constructor(private notificationsWebServiceClient: INotificationsWebServiceClient) {
  }

  resolve() {
    return this.notificationsWebServiceClient.findSubscribleCanalNotifications();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/canaux/gestion-canaux.resolver.ts